import { saveAs } from 'file-saver';

const base64ToBlob = (data: string, contentType = 'application/octet-stream', sliceSize = 512) => {
    const characters = atob(data);
    const blobParts = [];

    for(let offset = 0; offset < characters.length; offset += sliceSize) {
        const slice = characters.slice(offset, offset + sliceSize);

        const numbers = new Array(slice.length);

        for(let i = 0; i < slice.length; i += 1) {
            numbers[i] = slice.charCodeAt(i);
        }

        blobParts.push(new Uint8Array(numbers));
    }

    return new Blob(blobParts, { type: contentType });
};

export const downloadFile = async (response: Response, filename: string, autodetect = true) => {
    if(response.ok) {
        if(autodetect) {
            const contentType = response.headers.get('Content-Type');

            try {
                if(contentType?.includes('application/json')) {
                    const { data = undefined } = await response.json();

                    if(typeof data === 'string') {
                        saveAs(base64ToBlob(data), filename);

                        return;
                    }
                }
            } catch(e) {
                console.warn(e);
            }
        }
        const blob = await response.blob();

        saveAs(blob, filename);
    } else {
        return response;
    }
};
